export const OneNetworkStoreContextActionType = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED',
  ERROR: 'ERROR',
}

export const OneNetworkStoreAuthActionTypes = {
  WAITING: 'WAITING',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  LOGOUT: 'LOGOUT',
  LOGINED: 'LOGINED',
  FETCHING: 'FETCHING',
}
